import { Link } from 'react-router-dom';

export default function Footer() {
  const legalLinkStyle = {
    fontFamily: 'var(--font-condensed)',
    fontSize: 13,
    letterSpacing: '0.14em',
    color: 'rgba(245,168,0,0.42)',
    textTransform: 'uppercase',
    textDecoration: 'none',
    transition: 'color 0.2s',
  };

  return (
    <footer style={{ background: '#000' }}>
      <div style={{
        height: 10,
        backgroundImage: 'repeating-linear-gradient(-45deg, #F5A800 0, #F5A800 8px, #000 8px, #000 16px)',
      }} />

      <div style={{
        padding: '1.75rem 2rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '1rem',
        maxWidth: 1200,
        margin: '0 auto',
      }}>
        <img
          src="/logo.png"
          alt="Big Country Energy"
          style={{ height: 34, width: 'auto' }}
          onError={e => { e.target.style.display = 'none'; }}
        />

        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '0.9rem',
        }}>
          <div style={{
            fontFamily: 'var(--font-condensed)',
            fontSize: 13,
            letterSpacing: '0.2em',
            color: 'rgba(255,255,255,0.28)',
            textTransform: 'uppercase',
          }}>
            BIGGER - STRONGER - UNITED
          </div>
          <Link
            to="/privacy"
            style={legalLinkStyle}
            onMouseEnter={e => { e.currentTarget.style.color = 'rgba(245,168,0,0.8)'; }}
            onMouseLeave={e => { e.currentTarget.style.color = 'rgba(245,168,0,0.42)'; }}
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            style={legalLinkStyle}
            onMouseEnter={e => { e.currentTarget.style.color = 'rgba(245,168,0,0.8)'; }}
            onMouseLeave={e => { e.currentTarget.style.color = 'rgba(245,168,0,0.42)'; }}
          >
            Terms
          </Link>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 5 }}>
          <div style={{
            fontSize: 13,
            color: 'rgba(255,255,255,0.24)',
            fontFamily: 'var(--font-condensed)',
            letterSpacing: '0.08em',
          }}>
            (c) 2026 BIG COUNTRY ENERGY
          </div>
          <a
            href="https://discord.com/invite/9PmggjVYfj"
            target="_blank"
            rel="noreferrer"
            style={{
              fontFamily: 'var(--font-condensed)',
              fontSize: 15,
              letterSpacing: '0.14em',
              color: 'rgba(245,168,0,0.5)',
              textTransform: 'uppercase',
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.color = 'rgba(245,168,0,0.9)'; }}
            onMouseLeave={e => { e.currentTarget.style.color = 'rgba(245,168,0,0.5)'; }}
          >
            Made by Yeremii
          </a>
        </div>
      </div>
    </footer>
  );
}
